export const backgroundColors = {
    "/portfolio/anand-sweets": "#1B1830",
    "/portfolio/yogabar": "#0C052B",
    "/portfolio/nourysh": "#01191F",
    "/portfolio/dr-vaidya": "#083544",
    "/portfolio/giver-nutritions": "#2E170A",
    "/portfolio/bayla": "#2C3001",
    "/portfolio/chhappanbhog": "#171C26",
    "/portfolio/prakruti": "#022816",
    "/portfolio/hyfun": "#102602",
    "/portfolio/hamdard": "#2E0304",
    "/portfolio/thenga": "#231302",
    "/portfolio/shistaka": "#241B03",
    "/portfolio/sportsaber": "#260C04",
    "/portfolio/dl-films": "#171717",
    "/portfolio/ubar": "#401603",
    "/portfolio/freshleaf": "#212721",
    "/portfolio/radhey-sweets": "#04272E",
    "/portfolio/healthoxide": "#052F46",
    "/portfolio/maa-and-baby": "#014263",
    "/portfolio/gogrub": "#031929",
    "/portfolio/ekki-bekki": "#07313C",
    "/portfolio/mypro": "#161616",
    "/portfolio/teatox-life": "#0D2318",
    "/portfolio/aumex": "#050121",
    "/portfolio/greenfay": "#2E0B01",
    "/portfolio/paperclip-and-co": "#040328",
    "/portfolio/naturare": "#011A0D",
    "/portfolio/fast-n-fry": "#130F0F",
    "/portfolio/neo-roots": "#14332C",
    "/portfolio/within-beauty": "#412382",
    "/portfolio/uppercase": "#063541",
    "/portfolio/om-sweets": "#C01F25",
    "/portfolio/healing-hands": "#032C2F",
    "/portfolio/yo-gathiya": "#7C0A21",
    "/portfolio/codifi": "#311367",
    "/portfolio/terahash-solutions": "#0F0F0F",
    "/portfolio/kutum-ayurveda": "#975C24",
    "/portfolio/arospice": "#204F34",
    "/portfolio/fone-network": "#07083A",
    "/portfolio/repeat-gud": "#131313",
    "/portfolio/nurdle": "#1E2B3C",
    "/portfolio/aurolab": "#005268",
    "/portfolio/technosport": "#1B1B1B",
    "/portfolio/westerville": "#202C39",
    "/portfolio/myoa-cookies": "#29120F",
    "/portfolio/spark-fusion": "#151213",
    "/portfolio/bontrue-furniture": "#280E0A",
    "/portfolio/bhagavad-gita": "#451018",
    "/portfolio/weight-manage": "#262626",
    "/portfolio/agarwalbhavan-sweets": "#171616",
    "/portfolio/murari-sweets": "#192658",
    "/portfolio/singlas-sweets": "#230E0F",
    "/portfolio/savani-jewellery": "#E6BB8A",
    "/portfolio/bodyart": "#181A1F",
    "/portfolio/mia": "#3A1B59",
    "/portfolio/gpulla-reddy-sweets": "#111",
    "/portfolio/chaknow": "#1A1617",
    "/portfolio/instant-cash-price": "#171A29",
    "/portfolio/my-red-palette": "#121212",
    "/portfolio/outer-world": "#F5F5F5",
    "/portfolio/maison-de-jarin": "#141414",
    "/portfolio/maadico": "#000E1C",
    "/portfolio/tomahawk": "#03070D",
    "/portfolio/ayurmedix": "#1F5429",
    "/portfolio/chaykra": "#002459",
    "/portfolio/wobb-india": "#141414",
    "/portfolio/sevpoori": "#140C03",
    "/portfolio/great-old-days": "#260D06",
    "/portfolio/sinclairs-hotels": "#FFF",
    "/portfolio/shift-eco": "#EDEDED",
    "/portfolio/mom-3.0": "#BFA48E",
    "/portfolio/glosense": "#F5F5F5",
    "/portfolio/silverfied": "#F5F5F5",
    "/portfolio/elder": "#F5F5F5",
    "/portfolio": "#222",
    "/portfolio/branding/abox": "#222222",
    "/portfolio/branding/terahash-solutions": "#0F0F0F",
    "/portfolio/branding/nourysh": "#36386D",
    "/portfolio/branding/healing-hands": "#02363A",
    "/portfolio/branding/jiva-ayush": "#1E391C",
    "/portfolio/branding/omnes": "#1F1F2D",
    "/portfolio/branding/fast-n-fry": "#B81E1C",
    "/portfolio/branding/velora": "#1A1A1A",
    "/portfolio/branding/tokyo-fix": "#300D03",
    "/portfolio/branding/oval": "#282828",
    "/portfolio/branding/70pc": "#2C0273",
    "/portfolio/branding/typical": "#222222",

    "/portfolio/ui/growth-hive": "#040509",
    "/portfolio/ui/jammbo": "#053328",
    "/portfolio/ui/vijaya-lakshmi-silk": "#19181A",
}

export const borderColors = {
    "/portfolio/ui/jammbo": "#084D3C",
    "/portfolio/ui/growth-hive": "#00C0FF66",
    "/portfolio/ui/vijaya-lakshmi-silk": "#332C2E",
}

export const fontColors = {
    "/portfolio/anand-sweets": "#C9C5E6",
    "/portfolio/yogabar": "#E3DCFF",
    "/portfolio/nourysh": "#FFFFFF",
    "/portfolio/dr-vaidya": "#BDF0FF",
    "/portfolio/giver-nutritions": "#FFFFFF",
    "/portfolio/bayla": "#FFFFFF",
    "/portfolio/chhappanbhog": "#BED2FF",
    "/portfolio/prakruti": "#90E3BD",
    "/portfolio/hyfun": "#DEFBCC",
    "/portfolio/hamdard": "#FBE5E6",
    "/portfolio/thenga": "#EDEAE0",
    "/portfolio/shistaka": "#F2E2BA",
    "/portfolio/sportsaber": "#efebe7",
    "/portfolio/dl-films": "#FFFFFF",
    "/portfolio/ubar": "#FFFFFF",
    "/portfolio/freshleaf": "#FFFFFF",
    "/portfolio/radhey-sweets": "#FFFFFF",
    "/portfolio/healthoxide": "#FFFFFF",
    "/portfolio/maa-and-baby": "#E8FAFF",
    "/portfolio/gogrub": "#E8FAFF",
    "/portfolio/ekki-bekki": "#E8FAFF",
    "/portfolio/mypro": "#E8FAFF",
    "/portfolio/teatox-life": "#E8FAFF",
    "/portfolio/aumex": "#E8FAFF",
    "/portfolio/greenfay": "#E8FAFF",
    "/portfolio/paperclip-and-co": "#E8FAFF",
    "/portfolio/naturare": "#E8FAFF",
    "/portfolio/fast-n-fry": "#E8FAFF",
    "/portfolio/neo-roots": "#E8FAFF",
    "/portfolio/within-beauty": "#E3DCFF",
    "/portfolio/uppercase": "#D1F2F8",
    "/portfolio/om-sweets": "#FBF4EC",
    "/portfolio/healing-hands": "#FFFFFF",
    "/portfolio/yo-gathiya": "#FFFFFF",
    "/portfolio/codifi": "#FFFFFF",
    "/portfolio/terahash-solutions": "#FFFFFF",
    "/portfolio/kutum-ayurveda": "#FFFFFF",
    "/portfolio/arospice": "#FFFFFF",
    "/portfolio/fone-network": "#FFFFFF",
    "/portfolio/repeat-gud": "#FFFFFF",
    "/portfolio/nurdle": "#FFFFFF",
    "/portfolio/aurolab": "#FFFFFF",
    "/portfolio/technosport": "#FFFFFF",
    "/portfolio/westerville": "#FFFFFF",
    "/portfolio/myoa-cookies": "#FFFFFF",
    "/portfolio/spark-fusion": "#FFFFFF",
    "/portfolio/bontrue-furniture": "#FFFFFF",
    "/portfolio/bhagavad-gita": "#FFFFFF",
    "/portfolio/weight-manage": "#FFFFFF",
    "/portfolio/agarwalbhavan-sweets": "#FFFFFF",
    "/portfolio/murari-sweets": "#FFFFFF",
    "/portfolio/singlas-sweets": "#FFFFFF",
    "/portfolio/savani-jewellery": "#4D4D4D",
    "/portfolio/bodyart": "#D4D7DA",
    "/portfolio/mia": "#F5ECFF",
    "/portfolio/gpulla-reddy-sweets": "#F3F3F3",
    "/portfolio/chaknow": "#D2D2D2",
    "/portfolio/instant-cash-price": "#C7CADB",
    "/portfolio/my-red-palette": "#F3F3F3",
    "/portfolio/outer-world": "#231F20",
    "/portfolio/maison-de-jarin": "#E3E3E3",
    "/portfolio/maadico": "#B9C6D3",
    "/portfolio/tomahawk": "#B9C6D3",
    "/portfolio/ayurmedix": "#AED9CF",
    "/portfolio/chaykra": "#FFFFFF",
    "/portfolio/wobb-india": "#FFFFFF",
    "/portfolio/sevpoori": "#FFE6CC",
    "/portfolio/great-old-days": "#FFE6CC",
    "/portfolio/sinclairs-hotels": "#222",
    "/portfolio/shift-eco": "#231F20",
    "/portfolio/mom-3.0": "#4D3623",
    "/portfolio/glosense": "#231F20",
    "/portfolio/silverfied": "#231F20",
    "/portfolio/elder": "#231F20",
    "/portfolio": "#EFEBE7",
    "/portfolio/branding/abox": "#ffffff",
    "/portfolio/branding/terahash-solutions": "#C9C5E6",
    "/portfolio/branding/nourysh": "#C9C5E6",
    "/portfolio/branding/healing-hands": "#C9C5E6",
    "/portfolio/branding/jiva-ayush": "#FFFFFF",
    "/portfolio/branding/omnes": "#FFFFFF",
    "/conversion-rate-optimizations": "#004737",
    "/portfolio/branding/fast-n-fry": "#FFFFFF",
    "/portfolio/branding/velora": "#FFFFFF",
    "/portfolio/branding/tokyo-fix": "#FFFFFF",
    "/portfolio/branding/oval": "#FFFFFF",
    "/portfolio/branding/70pc": "#FFFFFF",
    "/portfolio/branding/typical": "#FFFFFF",

    "/portfolio/ui/growth-hive": "#AED9CF",
    "/portfolio/ui/jammbo": "#AED9CF",
    "/portfolio/ui/vijaya-lakshmi-silk": "#D2D2D2",
}

export const buttonColors = {
    "/services/shopify": "#222222",
    "/services/ui-ux": "#222222",
    "/services/visual-identity": "#222222",
    "/services/visual-identity": "#222222",
    "/services/ui-ux": "#222222",
    "/services/web-design": "#222222",
    "/services/graphic-design": "#222222",
    "/services/packaging-design": "#222222",
    "/services/web-design": "#222222",
    "/services/web-development": "#222222",
    "/services/seo": "#222222",
    "/services/for-startup": "#222222",
    "/services/ab-testing": "#222222",
    "/new-services": "#222222",
    "/new-services/ui-ux": "#222222",
    "/new-services/visual-identity": "#222222",
    "/new-services/web-design": "#222222",
    "/new-services/graphic-design": "#222222",
    "/new-services/packaging-design": "#222222",
    "/new-services/shopify-development": "#222222",
    "/new-services/shopify-plus-development": "#222222",
    "/new-services/shopify-migration": "#222222",
    "/new-services/headless-commerce": "#222222",
    "/new-services/cro": "#222222",
    "/new-services/ab-testing": "#222222",
    "/new-services/store-performance": "#222222",
    "/services/cro": "#222222",
    "/services/store-performance": "#222222",
    "/services/3d-render": "#222222",
    "/portfolio/fragstalk": "#417B5A",
    "/portfolio/anandhaas": "#417B5A",
    "/portfolio/fruzo": "#417B5A",
    "/portfolio/eustress": "#417B5A",
    "/portfolio/waylon-smith": "#417B5A",
    "/portfolio/oval": "#417B5A",
    "/conversion-rate-optimization": "#004737",

    "/portfolio": "#EFEBE7",
    "/portfolio/anand-sweets": "#9C8EFF",
    "/portfolio/yogabar": "#A1A7FF",
    "/portfolio/nourysh": "#E1E4FF",
    "/portfolio/dr-vaidya": "#BDF0FF",
    "/portfolio/giver-nutritions": "#FFD4AC",
    "/portfolio/bayla": "#EFFFBE",
    "/portfolio/chhappanbhog": "#BED2FF",
    "/portfolio/prakruti": "#90E3BD",
    "/portfolio/hyfun": "#DEFBCC",
    "/portfolio/hamdard": "#FBE5E6",
    "/portfolio/thenga": "#EDEAE0",
    "/portfolio/shistaka": "#F2E2BA",
    "/portfolio/sportsaber": "#EF6940",
    "/portfolio/dl-films": "#F5F1EB",
    "/portfolio/ubar": "#F5D8CB",
    "/portfolio/freshleaf": "#F5FAE2",
    "/portfolio/radhey-sweets": "#FFFBD2",
    "/portfolio/healthoxide": "#E8FAFF",
    "/portfolio/maa-and-baby": "#E8FAFF",
    "/portfolio/gogrub": "#E8FAFF",
    "/portfolio/ekki-bekki": "#E8FAFF",
    "/portfolio/mypro": "#E8FAFF",
    "/portfolio/teatox-life": "#E8FAFF",
    "/portfolio/aumex": "#E8FAFF",
    "/portfolio/greenfay": "#E8FAFF",
    "/portfolio/paperclip-and-co": "#E8FAFF",
    "/portfolio/naturare": "#E8FAFF",
    "/portfolio/fast-n-fry": "#E8FAFF",
    "/portfolio/neo-roots": "#E8FAFF",
    "/portfolio/within-beauty": "#A976FB",
    "/portfolio/uppercase": "#8AC5CF",
    "/portfolio/om-sweets": "#E89580",
    "/portfolio/healing-hands": "#AAF9FF",
    "/portfolio/yo-gathiya": "#932138",
    "/portfolio/codifi": "#A38DC9",
    "/portfolio/terahash-solutions": "#2E2E2E",
    "/portfolio/kutum-ayurveda": "#C29468",
    "/portfolio/arospice": "#69917A",
    "/portfolio/fone-network": "#2B2DAE",
    "/portfolio/repeat-gud": "#373737",
    "/portfolio/nurdle": "#808B9A",
    "/portfolio/aurolab": "#4C94A7",
    "/portfolio/technosport": "#595959",
    "/portfolio/westerville": "#657789",
    "/portfolio/myoa-cookies": "#8C705F",
    "/portfolio/spark-fusion": "#7B7879",
    "/portfolio/bontrue-furniture": "#5B413D",
    "/portfolio/bhagavad-gita": "#641622",
    "/portfolio/weight-manage": "#424242",
    "/portfolio/agarwalbhavan-sweets": "#4D4949",
    "/portfolio/murari-sweets": "#475DB6",
    "/portfolio/singlas-sweets": "#3D1F21",
    "/portfolio/savani-jewellery": "#4D4D4D",
    "/portfolio/bodyart": "#5C6271",
    "/portfolio/mia": "#8B63B2",
    "/portfolio/gpulla-reddy-sweets": "#424242",
    "/portfolio/chaknow": "#292526",
    "/portfolio/instant-cash-price": "#252941",
    "/portfolio/my-red-palette": "#424242",
    "/portfolio/outer-world": "#D9D9D9",
    "/portfolio/maison-de-jarin": "#3E3D3D",
    "/portfolio/maadico": "#304254",
    "/portfolio/tomahawk": "#FFA600",
    "/portfolio/ayurmedix": "#B3D334",
    "/portfolio/chaykra": "#0041A3",
    "/portfolio/wobb-india": "#222",
    "/portfolio/sevpoori": "#46280C",
    "/portfolio/great-old-days": "#522518",
    "/portfolio/sinclairs-hotels": "#006B54",
    "/portfolio/shift-eco": "#E3E2E1",
    "/portfolio/mom-3.0": "#806753",
    "/portfolio/glosense": "#D9D9D9",
    "/portfolio/silverfied": "#D9D9D9",
    "/portfolio/elder": "#D9D9D9",

    "/portfolio/branding/abox": "#ffffff",
    "/portfolio/branding/terahash-solutions": "#2E2E2E",
    "/portfolio/branding/nourysh": "#898CE2",
    "/portfolio/branding/healing-hands": "#088691",
    "/portfolio/branding/jiva-ayush": "#389237",
    "/portfolio/branding/omnes": "#1773EF",
    "/portfolio/branding/fast-n-fry": "#FFBC38",
    "/portfolio/branding/velora": "#1A1A1A",
    "/portfolio/branding/tokyo-fix": "#FA633B",
    "/portfolio/branding/oval": "#F37020",
    "/portfolio/branding/70pc": "#8B2BE4",
    "/portfolio/branding/typical": "#EEEEEE",

    "/portfolio/ui/growth-hive": "#00C0FF",
    "/portfolio/ui/jammbo": "#00664E",
    "/portfolio/ui/vijaya-lakshmi-silk": "#353132",
}

export const buttonFontColors = {
    "/portfolio": "#222222",
    "/portfolio/anand-sweets": "#FFFFFF",
    "/portfolio/yogabar": "#FFFFFF",
    "/portfolio/nourysh": "#222",
    "/portfolio/dr-vaidya": "#083544",
    "/portfolio/giver-nutritions": "#112E3B",
    "/portfolio/bayla": "#2C3001",
    "/portfolio/chhappanbhog": "#161920",
    "/portfolio/prakruti": "#1B1830",
    "/portfolio/hyfun": "#1B1830",
    "/portfolio/hamdard": "#1B1830",
    "/portfolio/thenga": "#1B1830",
    "/portfolio/shistaka": "#1B1830",
    "/portfolio/dl-films": "#222222",
    "/portfolio/ubar": "#401603",
    "/portfolio/freshleaf": "#212721",
    "/portfolio/radhey-sweets": "#04272E",
    "/portfolio/healthoxide": "#052F46",
    "/portfolio/maa-and-baby": "#222222",
    "/portfolio/gogrub": "#222222",
    "/portfolio/ekki-bekki": "#222222",
    "/portfolio/mypro": "#222222",
    "/portfolio/teatox-life": "#222222",
    "/portfolio/aumex": "#222222",
    "/portfolio/greenfay": "#222222",
    "/portfolio/paperclip-and-co": "#222222",
    "/portfolio/naturare": "#222222",
    "/portfolio/fast-n-fry": "#222222",
    "/portfolio/neo-roots": "#222222",
    "/portfolio/within-beauty": "#FFFFFF",
    "/portfolio/uppercase": "#FFFFFF",
    "/portfolio/om-sweets": "#FFFFFF",
    "/portfolio/healing-hands": "#032C2F",
    "/portfolio/yo-gathiya": "#FFFFFF",
    "/portfolio/codifi": "#FFFFFF",
    "/portfolio/terahash-solutions": "#FFFFFF",
    "/portfolio/kutum-ayurveda": "#FFFFFF",
    "/portfolio/arospice": "#FFFFFF",
    "/portfolio/fone-network": "#FFFFFF",
    "/portfolio/repeat-gud": "#FFFFFF",
    "/portfolio/nurdle": "#FFFFFF",
    "/portfolio/aurolab": "#FFFFFF",
    "/portfolio/technosport": "#FFFFFF",
    "/portfolio/westerville": "#FFFFFF",
    "/portfolio/myoa-cookies": "#FFFFFF",
    "/portfolio/spark-fusion": "#FFFFFF",
    "/portfolio/bontrue-furniture": "#FFFFFF",
    "/portfolio/bhagavad-gita": "#FFFFFF",
    "/portfolio/weight-manage": "#FFFFFF",
    "/portfolio/agarwalbhavan-sweets": "#FFFFFF",
    "/portfolio/murari-sweets": "#FFFFFF",
    "/portfolio/singlas-sweets": "#FFFFFF",
    "/portfolio/savani-jewellery": "#FFFFFF",
    "/portfolio/bodyart": "#D4D7DA",
    "/portfolio/mia": "#F5ECFF",
    "/portfolio/gpulla-reddy-sweets": "#F3F3F3",
    "/portfolio/chaknow": "#F3F3F3",
    "/portfolio/instant-cash-price": "#C7CADB",
    "/portfolio/my-red-palette": "#F3F3F3",
    "/portfolio/outer-world": "#231F20",
    "/portfolio/maison-de-jarin": "#E3E3E3",
    "/portfolio/maadico": "#B9C6D3",
    "/portfolio/tomahawk": "#0D1521",
    "/portfolio/ayurmedix": "#1F5429",
    "/portfolio/chaykra": "#ffffff",
    "/portfolio/wobb-india": "#ffffff",
    "/portfolio/great-old-days": "#FFE6CC",
    "/portfolio/sinclairs-hotels": "#FFF",
    "/portfolio/shift-eco": "#231F20",
    "/portfolio/mom-3.0": "#fff",
    "/portfolio/glosense": "#231F20",
    "/portfolio/silverfied": "#231F20",
    "/portfolio/elder": "#231F20",

    "/portfolio/branding/abox": "#222222",
    "/portfolio/branding/terahash-solutions": "#FFFFFF",
    "/portfolio/branding/nourysh": "#FFFFFF",
    "/portfolio/branding/healing-hands": "#FFFFFF",
    "/portfolio/branding/jiva-ayush": "#FFFFFF",
    "/portfolio/branding/omnes": "#FFFFFF",
    "/portfolio/branding/fast-n-fry": "#B81E1C",
    "/portfolio/branding/velora": "#FFFFFF",
    "/portfolio/branding/tokyo-fix": "#FFFFFF",
    "/portfolio/branding/oval": "#FFFFFF",
    "/portfolio/branding/70pc": "#FFFFFF",
    "/portfolio/branding/typical": "#222222",

    "/portfolio/ui/growth-hive": "#040509",
    "/portfolio/ui/jammbo": "#AED9CF",
    "/portfolio/ui/vijaya-lakshmi-silk": "#F3F3F3",
}

export const svgColors = {
    "/conversion-rate-optimization": "#004737",

    "/portfolio": "#EFEBE7",
    "/portfolio/anand-sweets": "#9C8EFF",
    "/portfolio/yogabar": "#A1A7FF",
    "/portfolio/nourysh": "#E1E4FF",
    "/portfolio/dr-vaidya": "#BDF0FF",
    "/portfolio/giver-nutritions": "#FFD4AC",
    "/portfolio/bayla": "#EFFFBE",
    "/portfolio/chhappanbhog": "#BED2FF",
    "/portfolio/prakruti": "#90e3bd",
    "/portfolio/hyfun": "#DEFBCC",
    "/portfolio/hamdard": "#FBE5E6",
    "/portfolio/thenga": "#EDEAE0",
    "/portfolio/shistaka": "#F2E2BA",
    "/portfolio/sportsaber": "#EF6940",
    "/portfolio/dl-films": "#F5F1EB",
    "/portfolio/ubar": "#F5D8CB",
    "/portfolio/freshleaf": "#F5FAE2",
    "/portfolio/radhey-sweets": "#FFFBD2",
    "/portfolio/healthoxide": "#E8FAFF",
    "/portfolio/maa-and-baby": "#E8FAFF",
    "/portfolio/gogrub": "#E8FAFF",
    "/portfolio/ekki-bekki": "#E8FAFF",
    "/portfolio/mypro": "#E8FAFF",
    "/portfolio/teatox-life": "#E8FAFF",
    "/portfolio/aumex": "#E8FAFF",
    "/portfolio/greenfay": "#E8FAFF",
    "/portfolio/paperclip-and-co": "#E8FAFF",
    "/portfolio/naturare": "#E8FAFF",
    "/portfolio/fast-n-fry": "#E8FAFF",
    "/portfolio/neo-roots": "#E8FAFF",
    "/portfolio/within-beauty": "#A976FB",
    "/portfolio/uppercase": "#8AC5CF",
    "/portfolio/om-sweets": "#E89580",
    "/portfolio/healing-hands": "#AAF9FF",
    "/portfolio/yo-gathiya": "#F2B40D",
    "/portfolio/codifi": "#B394EA",
    "/portfolio/terahash-solutions": "#888888",
    "/portfolio/kutum-ayurveda": "#F2D6BB",
    "/portfolio/arospice": "#D4DFD9",
    "/portfolio/fone-network": "#5F61D7",
    "/portfolio/repeat-gud": "#C9C9C9",
    "/portfolio/nurdle": "#C9C9C9",
    "/portfolio/aurolab": "#B2D1D9",
    "/portfolio/technosport": "#B7B7B7",
    "/portfolio/westerville": "#B7B7B7",
    "/portfolio/myoa-cookies": "#F5DFBB",
    "/portfolio/spark-fusion": "#DFFF60",
    "/portfolio/bontrue-furniture": "#F3E5C5",
    "/portfolio/bhagavad-gita": "#C3C2C7",
    "/portfolio/weight-manage": "#CFCFCF",
    "/portfolio/agarwalbhavan-sweets": "#C3C2C7",
    "/portfolio/murari-sweets": "#5D8AC7",
    "/portfolio/singlas-sweets": "#A57760",
    "/portfolio/savani-jewellery": "#333333",
    "/portfolio/bodyart": "#D4D7DA",
    "/portfolio/mia": "#F5ECFF",
    "/portfolio/gpulla-reddy-sweets": "#F3F3F3",
    "/portfolio/chaknow": "#F9F9F9",
    "/portfolio/instant-cash-price": "#F9F9F9",
    "/portfolio/my-red-palette": "#F3F3F3",
    "/portfolio/outer-world": "#231F20",
    "/portfolio/maison-de-jarin": "#E3E3E3",
    "/portfolio/maadico": "#E3E3E3",
    "/portfolio/tomahawk": "#E3E3E3",
    "/portfolio/ayurmedix": "#F9F9F9",
    "/portfolio/chaykra": "#ffffff",
    "/portfolio/wobb-india": "#ffffff",
    "/portfolio/sevpoori": "#FFE6CC",
    "/portfolio/great-old-days": "#FFF",
    "/portfolio/shift-eco": "#231F20",
    "/portfolio/mom-3.0": "#4D3623",
    "/portfolio/glosense": "#231F20",
    "/portfolio/silverfied": "#231F20",
    "/portfolio/elder": "#231F20",

    "/portfolio/branding/abox": "#ffffff",
    "/portfolio/branding/terahash-solutions": "#ffffff",
    "/portfolio/branding/nourysh": "#A6A9E9",
    "/portfolio/branding/healing-hands": "#AAF9FF",
    "/portfolio/branding/jiva-ayush": "#FFFFFF",
    "/portfolio/branding/omnes": "#FFFFFF",
    "/portfolio/branding/fast-n-fry": "#FFFFFF",
    "/portfolio/branding/velora": "#FFFFFF",
    "/portfolio/branding/tokyo-fix": "#FFFFFF",
    "/portfolio/branding/oval": "#FFFFFF",
    "/portfolio/branding/70pc": "#FFFFFF",
    "/portfolio/branding/typical": "#FFFFFF",

    "/portfolio/ui/growth-hive": "#F9F9F9",
    "/portfolio/ui/jammbo": "#F9F9F9",
    "/portfolio/ui/vijaya-lakshmi-silk": "#F9F9F9",
}

export const CopyLinkColors = {
    "/portfolio/anand-sweets": "#FFFFFF",
    "/portfolio/yogabar": "#FFFFFF",
    "/portfolio/nourysh": "#012028",
    "/portfolio/dr-vaidya": "#FFFFFF",
    "/portfolio/giver-nutritions": "#2E170A",
    "/portfolio/bayla": "#FFFFFF",
    "/portfolio/chhappanbhog": "#FFFFFF",
    "/portfolio/prakruti": "#FFFFFF",
    "/portfolio/hyfun": "#FFFFFF",
    "/portfolio/hamdard": "#FFFFFF",
    "/portfolio/thenga": "#FFFFFF",
    "/portfolio/shistaka": "#FFFFFF",
    "/portfolio/sportsaber": "#FFFFFF",
    "/portfolio/dl-films": "#171717",
    "/portfolio/ubar": "#171717",
    "/portfolio/freshleaf": "#FFFFFF",
    "/portfolio/radhey-sweets": "#04272E",
    "/portfolio/healthoxide": "#171717",
    "/portfolio/maa-and-baby": "#171717",
    "/portfolio/gogrub": "#171717",
    "/portfolio/mypro": "#171717",
    "/portfolio/teatox-life": "#171717",
    "/portfolio/ekki-bekki": "#171717",
    "/portfolio/aumex": "#171717",
    "/portfolio/greenfay": "#171717",
    "/portfolio/paperclip-and-co": "#171717",
    "/portfolio/naturare": "#171717",
    "/portfolio/fast-n-fry": "#171717",
    "/portfolio/neo-roots": "#171717",
    "/portfolio/within-beauty": "#FFFFFF",
    "/portfolio/uppercase": "#FFFFFF",
    "/portfolio/om-sweets": "#FFFFFF",
    "/portfolio/healing-hands": "#FFFFFF",
    "/portfolio/yo-gathiya": "#171717",
    "/portfolio/codifi": "#FFFFFF",
    "/portfolio/terahash-solutions": "#FFFFFF",
    "/portfolio/kutum-ayurveda": "#171717",
    "/portfolio/arospice": "#FFFFFF",
    "/portfolio/fone-network": "#FFFFFF",
    "/portfolio/repeat-gud": "#171717",
    "/portfolio/nurdle": "#FFFFFF",
    "/portfolio/aurolab": "#FFFFFF",
    "/portfolio/technosport": "#FFFFFF",
    "/portfolio/westerville": "#FFFFFF",
    "/portfolio/myoa-cookies": "#FFFFFF",
    "/portfolio/spark-fusion": "#FFFFFF",
    "/portfolio/bontrue-furniture": "#FFFFFF",
    "/portfolio/bhagavad-gita": "#FFFFFF",
    "/portfolio/weight-manage": "#FFFFFF",
    "/portfolio/agarwalbhavan-sweets": "#FFFFFF",
    "/portfolio/murari-sweets": "#FFFFFF",
    "/portfolio/singlas-sweets": "#FFFFFF",
    "/portfolio/savani-jewellery": "#FFFFFF",
    "/portfolio/bodyart": "#D4D7DA",
    "/portfolio/mia": "#F5ECFF",
    "/portfolio/gpulla-reddy-sweets": "#FFFFFF",
    "/portfolio/chaknow": "#FFFFFF",
    "/portfolio/instant-cash-price": "#C7CADB",
    "/portfolio/my-red-palette": "#FFFFFF",
    "/portfolio/outer-world": "#ffffff",
    "/portfolio/maison-de-jarin": "#FFFFFF",
    "/portfolio/maadico": "#E3E3E3",
    "/portfolio/tomahawk": "#D0E3FF",
    "/portfolio/ayurmedix": "#1F5429",
    "/portfolio/chaykra": "#ffffff",
    "/portfolio/wobb-india": "#ffffff",
    "/portfolio/sevpoori": "#FFE6CC",
    "/portfolio/great-old-days": "#FFE6CC",
    "/portfolio/sinclairs-hotels": "#AED9CF",
    "/portfolio/shift-eco": "#FFFFFF",
    "/portfolio/mom-3.0": "#FFFFFF",
    "/portfolio/glosense": "#FFFFFF",
    "/portfolio/silverfied": "#FFFFFF",
    "/portfolio/elder": "#FFFFFF",

    "/portfolio/ui/teatox-life": "#222222",
    "/portfolio/ui/growth-hive": "#040509",
    "/portfolio/ui/vijaya-lakshmi-silk": "#FFFFFF",
}

export const footerBG = {
    "/conversion-rate-optimization": "#004737",
}

export const footerColor = {
    "/conversion-rate-optimization": "#56F09F",
}

export const urls = {
    '/': '',
    '/contact': 'Contact',
    '/portfolio': 'Portfolio',
    '/services': 'Services',
    '/careers': 'Careers',
    '/about': 'About',
    '/clients': 'Clients',

    '/services/seo': 'SEO',
    '/services/web-development': 'Web Development',
    '/services/shopify': 'Shopify',
    '/services/visual-identity': 'Visual Identity',
    '/services/ui-ux': 'UI/UX',
    '/services/web-design': 'Web Design',
    '/services/for-startup': 'For Startup',
    '/services/ab-testing': 'A/B Testing',
    '/services/3d-render': '3D Render',
    '/portfolio/fragstalk': 'Fragstalk',
    '/portfolio/anandhaas': 'Anandhaas',
    '/portfolio/fruzo': 'Fruzo',
    '/portfolio/eustress': 'Eustress',
    '/portfolio/waylon-smith': 'Waylon Smith',
    '/portfolio/oval': 'Oval Health',

    '/new-services': 'Services',
    '/new-services/ui-ux': 'UI/UX',
    '/new-services/visual-identity': 'Visual Identity',
    '/new-services/web-design': 'Web Design',
    '/new-services/graphic-design': 'Graphic Design',
    '/new-services/packaging-design': 'Packaging Design',
    '/new-services/shopify-development': 'Shopify Development',
    '/new-services/shopify-plus-development': 'Shopify Plus Development',
    '/new-services/shopify-migration': 'Shopify Migration',
    '/new-services/headless-commerce': 'Headless Commerce',
    '/new-services/cro': 'CRO',
    '/new-services/ab-testing': 'A/B Testing',
    '/new-services/store-performance': 'Store Performance',

    '/portfolio/anand-sweets': 'Anand Sweets',
    '/portfolio/yogabar': 'Yogabar',
    '/portfolio/nourysh': 'Nourysh',
    '/portfolio/dr-vaidya': 'Dr. Vaidya',
    '/portfolio/giver-nutritions': 'Giver Nutritions',
    '/portfolio/bayla': 'Bayla Skin',
    '/portfolio/chhappanbhog': 'Chhappanbhog',
    '/portfolio/prakruti': 'Prakruti',
    '/portfolio/hyfun': 'Hyfun',
    '/portfolio/hamdard': 'Hamdard',
    '/portfolio/thenga': 'Thenga',
    '/portfolio/shistaka': 'Shistaka',
    '/portfolio/sportsaber': 'Sport Saber',
    "/portfolio/dl-films": "DL Films",
    "/portfolio/ubar": "Ubar",
    "/portfolio/freshleaf": "Fresh Leaf",
    "/portfolio/radhey-sweets": "Radhey Sweets",
    "/portfolio/healthoxide": "Healthoxide",
    '/portfolio/maa-and-baby': 'Maa & Baby',
    '/portfolio/gogrub': 'Go Grub',
    "/portfolio/mypro": "My Pro",
    "/portfolio/teatox-life": "TeaTox Life",
    '/portfolio/ekki-bekki': 'Ekki Bekki',
    '/portfolio/aumex': 'Aumex',
    '/portfolio/greenfay': 'Green Fay',
    '/portfolio/paperclip-and-co': 'Paperclip & Co',
    '/portfolio/naturare': 'Naturare',
    '/portfolio/fast-n-fry': 'Fast & Fry',
    '/portfolio/neo-roots': 'Neo Roots',
    "/portfolio/within-beauty": "Within Beauty",
    "/portfolio/uppercase": "Uppercase",
    "/portfolio/om-sweets": "Om Sweets & Snacks",
    "/portfolio/healing-hands": "Healing hands",
    "/portfolio/yo-gathiya": "Yo Gathiya",
    "/portfolio/codifi": "CodiFi",
    "/portfolio/terahash-solutions": "Terahash Solutions",
    "/portfolio/kutum-ayurveda": "Kutum Ayurveda",
    "/portfolio/arospice": "Arospice",
    "/portfolio/fone-network": "Fone Network",
    "/portfolio/repeat-gud": "Repeat Gud",
    "/portfolio/nurdle": "Nurdle",
    "/portfolio/aurolab": "AuroLab",
    "/portfolio/technosport": "Techno Sport",
    "/portfolio/westerville": "Westerville",
    "/portfolio/myoa-cookies": "Myoa Cookies",
    "/portfolio/spark-fusion": "Spark Fusion",
    "/portfolio/bontrue-furniture": "Bontrue Furniture",
    "/portfolio/bhagavad-gita": "Bhagavad-Gita",
    "/portfolio/weight-manage": "Weight Manage",
    "/portfolio/agarwalbhavan-sweets": "Agarwal Bhavan Sweets",
    "/portfolio/murari-sweets": "Murari Sweet",
    "/portfolio/singlas-sweets": "Singla’s Sweets",
    "/portfolio/savani-jewellery": "Savani Jewellery",
    "/portfolio/bodyart": "Body Art",
    "/portfolio/mia": "Mia My Inner Ally",
    "/portfolio/gpulla-reddy-sweets": "G. Pulla Reddy Sweets",
    "/portfolio/chaknow": "Chak Now",
    "/portfolio/instant-cash-price": "Instant Cash Price",
    "/portfolio/my-red-palette": "My Red Palette",
    "/portfolio/outer-world": "Outer World",
    "/portfolio/maison-de-jarin": "Maison De Jarin",
    "/portfolio/maadico": "Maadico",
    "/portfolio/tomahawk": "Tomahawk",
    "/portfolio/ayurmedix": "Ayurmedix",
    "/portfolio/chaykra": "Chaykra",
    "/portfolio/wobb-india": "Wobb India",
    "/portfolio/sevpoori": "Sevpoori",
    "/portfolio/great-old-days": "Great Old Days",
    "/portfolio/sinclairs-hotels": "Sinclairs",
    "/portfolio/shift-eco": "Shift Eco",
    "/portfolio/mom-3.0": "Mom 3.0",
    "/portfolio/glosense": "Glosense",
    "/portfolio/silverfied": "Silverfied",
    "/portfolio/elder": "Elder",

    '/portfolio/branding/abox': 'Abox',
    '/portfolio/branding/terahash-solutions': 'Terahash Solutions',
    '/portfolio/branding/nourysh': 'Nourysh',
    "/portfolio/branding/healing-hands": "Healing Hands",
    "/portfolio/branding/jiva-ayush": "Jiv Ayush",
    "/portfolio/branding/omnes": "Omnes",
    "/portfolio/branding/fast-n-fry": "Fast & Fry",
    "/portfolio/branding/velora": "Velora",
    "/portfolio/branding/tokyo-fix": "Tokyo Fix",
    "/portfolio/branding/oval": "Oval",
    "/portfolio/branding/70pc": "70pc",
    "/portfolio/branding/typical": "Typical",

    "/portfolio/ui/growth-hive": "Growth Hive",
    "/portfolio/ui/jammbo": "Jammbo",
    "/portfolio/ui/vijaya-lakshmi-silk": "Vijaya Lakshmi Silk",
} 